var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_Germany 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23455_7097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "black stripe",
    d: "M23.9983 0H0V15H23.9983V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "red stripe",
    d: "M23.9983 5H0V15H23.9983V5Z",
    fill: "#DD0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gold stripe",
    d: "M23.9983 10H0V15H23.9983V10Z",
    fill: "#FFCE00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23455_7097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9983,
    height: 15,
    rx: 2,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.37717dbd6d93f85122fbf0cd354d33c6.svg";
export { ForwardRef as ReactComponent };